import { render, staticRenderFns } from "./InvoiceAutomationBuilder.vue?vue&type=template&id=0c5fd0dd&scoped=true&"
import script from "./InvoiceAutomationBuilder.vue?vue&type=script&lang=js&"
export * from "./InvoiceAutomationBuilder.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAutomationBuilder.vue?vue&type=style&index=0&id=0c5fd0dd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5fd0dd",
  null
  
)

export default component.exports